/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import Loader from 'components/Loader'
import { CancellationUser } from '../types'
import { getFullName } from '../utils'
import * as classes from '../styles'

type Props = {
  users: CancellationUser[]
  loading: boolean
}

export const CancellationTestimonials = ({ users, loading }: Props) => {
  if (loading && !users.length) {
    return (
      <div css={[classes.statusCard, classes.statusLoader]}>
        <Loader />
      </div>
    )
  }

  if (!users.length) {
    return (
      <div css={classes.statusCard} data-testid="nothing-found">
        Nothing Found
      </div>
    )
  }

  return (
    <div css={classes.tableSection}>
      {users.map((user) => (
        <article key={user.id} css={classes.testimonialCard}>
          <div css={classes.testimonialIdentity}>
            <Typography css={classes.testimonialName}>{getFullName(user.firstName, user.lastName)}</Typography>
            <Typography css={classes.testimonialEmail}>{user.email || '-'}</Typography>
          </div>

          {user.cancellationComment ? <p css={classes.testimonialBody}>{user.cancellationComment}</p> : null}
        </article>
      ))}
    </div>
  )
}
